import { QuestionCircleOutlined } from '@ant-design/icons';
import { Alert, Col, Popover, Row, Switch } from 'antd';
import { Link } from 'react-router';

interface MissingSchedulesAlertProps {
  activeContractsCount: number;
  onShowMissingScheduleUsersChange: (checked: boolean) => void;
  showMissingScheduleUsers: boolean;
}

export const MissingSchedulesAlert = ({
  activeContractsCount,
  onShowMissingScheduleUsersChange,
  showMissingScheduleUsers,
}: MissingSchedulesAlertProps) => {
  if (activeContractsCount === 0) return null;

  return (
    <Row justify="center">
      <Col>
        <Alert
          message={
            <h3 className="employees-wo-schedules-title">
              Hay empleados que tienen contratos activos sin horarios
            </h3>
          }
          description={
            <Row>
              <Col>
                <p>
                  No se registrarán sus incidencias hasta que se les asigne un
                  horario.
                </p>
                <Row className="mt-2" align="middle">
                  <Col>
                    <Row>
                      <Col>
                        <Switch
                          onChange={onShowMissingScheduleUsersChange}
                          id="show-missing-schedule-employees"
                          data-cy="show-missing-schedule-employees-switch"
                          checked={showMissingScheduleUsers}
                        />
                      </Col>
                      <Col className="ml-2">
                        <span>Mostrar empleados sin horario</span>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={{ offset: 1 }}>
                    <Popover
                      content={
                        <Link
                          to="https://prosinergia.mx/ayuda/articulo/importancia-registrar-horarios-docentes"
                          target="_blank"
                        >
                          Ver artículo de ayuda
                        </Link>
                      }
                    >
                      <QuestionCircleOutlined className="help-employees-wo-schedules-icon" />
                    </Popover>
                  </Col>
                </Row>
              </Col>
            </Row>
          }
          type="error"
          showIcon
        />
      </Col>
    </Row>
  );
};
